import { createContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { createBrowserHistory } from "history";
import { ApiUrl } from "../utils/Properties";

const swal = require("sweetalert2");

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {

  const [authTokens, setAuthTokens] = useState(() =>
    localStorage.getItem("authTokens")
      ? JSON.parse(localStorage.getItem("authTokens"))
      : null
  );

  const [user, setUser] = useState(() =>
    localStorage.getItem("authTokens")
      ? jwtDecode(localStorage.getItem("authTokens"))
      : null
  );

  const [loading, setLoading] = useState(true);

  const history = createBrowserHistory();

  const loginUser = async (user, password) => {
    const response = await fetch(`${ApiUrl}/auth/jwt/create/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: user,
        password: password,
      }),
    });
    const data = await response.json();

    if (response.status === 200) {
      console.log("Logged In");
      setAuthTokens(data);
      setUser(jwtDecode(data.access));
      localStorage.setItem("authTokens", JSON.stringify(data));
      history.push("/dashboard");
      history.go();
    } else {
      console.log(response.status);
      swal.fire({
        title: "Usuario o contraseña incorrectos",
        icon: "error",
        toast: true,
        timer: 6000,
        position: "top-right",
        timerProgressBar: true,
        showConfirmButton: false,
      });
    }
  };

  const changePassUser = async (new_password, re_new_password, current_password) => {
    try {
      let token = JSON.parse(localStorage.getItem("authTokens"));
      const response = await fetch(`${ApiUrl}/auth/users/set_password/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `JWT ${token?.access}`
        },
        body: JSON.stringify({
          new_password: new_password,
          re_new_password: re_new_password,
          current_password: current_password
        }),
      });

      // Verificar si la respuesta contiene JSON válido
      const contentType = response.headers.get("content-type");
      let data = null;
      
      if (contentType && contentType.includes("application/json")) {
        data = await response.json();
      } else {
        // Si no es JSON, crear un objeto de error genérico
        data = { 
          error: "Respuesta no válida del servidor",
          status: response.status 
        };
      }

      if (response.status === 204 || response.status === 200) {
        return { success: true, data: data };
      } else {
        console.log('Error response status:', response.status);
        console.log('Error response data:', data);
        return { success: false, errors: data };
      }
    } catch (error) {
      console.error('Error en changePassUser:', error);
      return { 
        success: false, 
        errors: { 
          general: ["Error de conexión. Inténtelo nuevamente."] 
        } 
      };
    }
  }

  const userMeData = async () => {
    let token = JSON.parse(localStorage.getItem("authTokens"));
    const response = await fetch(`${ApiUrl}/auth/users/me/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `JWT ${token?.access}`
      },
    });
    const data = await response.json();
    if (response.status === 200) {
      return data;
    }
    else {
      console.log(response.status);
      return null;
    }
  }

  const logoutUser = () => {
    setAuthTokens(null);
    setUser(null);
    localStorage.removeItem("authTokens");
    history.push("/");
    history.go();
  };

  const contextData = {
    user,
    setUser,
    authTokens,
    setAuthTokens,
    loginUser,
    logoutUser,
    userMeData,
    changePassUser
  };

  useEffect(() => {
    if (authTokens) {
      setUser(jwtDecode(authTokens.access));
    }
    setLoading(false);
  }, [authTokens, loading]);

  return (
    <AuthContext.Provider value={contextData}>
      {loading ? null : children}
    </AuthContext.Provider>
  );
};
